export default __webpack_public_path__ + "static/media/touchZero.a8592569.svg";